import React, { useState } from 'react'; // <-- ADD useState
import { Link } from 'react-router-dom';
import { allCars } from './carData';

const carTypes = ['Select car type', ...new Set(allCars.map(car => car.type)), 'Luxury'];

const indianStatesAndUTs = [
  'Select place',
  'Andaman and Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
];

// --- UPDATED Booking Form Component ---
const BookingForm = () => {
  const [formData, setFormData] = useState({});
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(''); 

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage(null); 
    
    try {
      const response = await fetch('http://localhost:4000/api/booking/book_car', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
        credentials: 'include',
      });

      const data = await response.json();

      if (response.ok) {
        // Successful booking request
        setMessage(`Success! ${data.message} Please call us at ${data.companyPhone} to confirm.`);
        setMessageType('success');
      } else if (response.status === 401) {
        // User not logged in (Unauthorized)
        setMessage('You must be logged in to book a car. Please sign in or sign up!');
        setMessageType('error');
      } else {
        // Other errors (e.g., missing fields)
        setMessage(data.message || 'Booking failed. Check all fields and try again.');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setMessage('Network error. Could not connect to the server.');
      setMessageType('error');
    }
  };

  return (
    <div className="w-full lg:w-2/5 rounded-2xl shadow-xl p-8 mt-8 lg:mt-0">
      <h2 className="text-2xl font-bold text-white mb-6">Book your car</h2>
      
      {/* Success/Error Message Display */}
      {message && (
        <div 
          className={`p-3 rounded-lg mb-4 font-semibold ${
            messageType === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'
          }`}
        >
          {message}
        </div>
      )}
      
      <form onSubmit={handleFormSubmit} className="space-y-5">
        
        <div>
          <label htmlFor="carType" className="block text-sm font-medium text-slate-400 mb-1">Car type</label>
          <select 
            id="carType" 
            name="carType" 
            onChange={handleFormChange}
            required
            className="w-full border-b-2 border-amber-400 bg-slate-800 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select car type"
          >
            {carTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="placeOfRental" className="block text-sm font-medium text-slate-400 mb-1">Place of rental</label>
          <select 
            id="placeOfRental" 
            name="placeOfRental" 
            onChange={handleFormChange}
            required
            className="w-full border-b-2 border-amber-400 bg-slate-800 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select place"
          >
            {indianStatesAndUTs.map(place => (
              <option key={place} value={place}>{place}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="placeOfReturn" className="block text-sm font-medium text-slate-400 mb-1">Place of return</label>
          <select 
            id="placeOfReturn" 
            name="placeOfReturn" 
            onChange={handleFormChange}
            className="w-full border-b-2 border-amber-400 bg-slate-800 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select place"
          >
            {indianStatesAndUTs.map(place => (
              <option key={place} value={place}>{place}</option>
            ))}
          </select>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="rentalDate" className="block text-sm font-medium text-slate-400 mb-1">Rental date</label>
            <input 
              type="date" 
              id="rentalDate" 
              name="rentalDate"
              onChange={handleFormChange}
              required
              className="w-full border-b-2 border-amber-400 bg-slate-800 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
          <div>
            <label htmlFor="returnDate" className="block text-sm font-medium text-slate-400 mb-1">Return date</label>
            <input 
              type="date" 
              id="returnDate" 
              name="returnDate"
              onChange={handleFormChange}
              className="w-full border-b-2 border-amber-400 bg-slate-800 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
        </div>
        
        <button 
          type="submit"
          className="w-full bg-amber-400 text-slate-950 font-bold py-3 px-6 rounded-lg hover:bg-amber-500 transition duration-300"
        >
          Book now
        </button>
      </form>
    </div>
  );
};


const Hero = () => {
  return (
    <section>
      <div 
        className="bg-slate-800 relative overflow-hidden bg-blend-soft-light min-h-screen flex flex-col flex-grow"
        style={{ backgroundImage: "url('/assets/2021-BMW-M4-Competition.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-black opacity-70"></div>
        
        <div className="flex flex-col lg:flex-row justify-between items-center relative z-10 p-8 md:p-16 pt-20 h-full flex-grow max-w-7xl mx-auto">
          
          <div className="lg:w-3/5 text-white">
            <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4">
              Experience the road like never before
            </h1>
            <p className="text-lg text-slate-400 mb-8 max-w-lg">
              Aliquam adipiscing velit semper morbi. Purus non eu cursus porttitor tristique et gravida. Quis nunc interdum gravida ullamcorper
            </p>
            <Link 
              to="/vehicles" 
              className="bg-amber-400 text-slate-950 font-bold py-3 px-6 rounded-lg hover:bg-amber-500 transition duration-300"
            >
              View all cars
            </Link>
          </div>

          <BookingForm />
        </div>
      </div>
    </section>
  );
}

export default Hero;